export default "__VITE_ASSET__CT1Cmp7f__"